// -----------------------------------------------------------------------
// <copyright file="QueryType.ts" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

export enum QueryType {
    UserTyped = 'UserTyped',
    Deeplink = 'Deeplink',
    AutoSuggest = 'AutoSuggest'
}
  